<template>
    <div class="row mt-4">
        <p>Для оформления членства необходимо:</p>
        <div class="list-group">
            <PassportDataManualSection header="Заполнить паспортные данные" :open="showPassportSection" @click="showPassportSection = !showPassportSection" />

            <PhotoUploadManualSection header="Загрузить фотографию" :open="showPhotoUploadSection" @click="showPhotoUploadSection = !showPhotoUploadSection" />

            <ContactDataManualSection header="Указать контактные данные" :open="showContactDataSection" @click="showContactDataSection = !showContactDataSection" />

            <PassportScanUploadManualSection header="Загрузить скан разворота паспорта" :open="showUploadPassportScanSection" @click="showUploadPassportScanSection = !showUploadPassportScanSection" />

            <RequestScanUploadManualSection header="Загрузить скан подписанного заявления на вступление" :open="showUploadRequestScanSection" @click="showUploadRequestScanSection = !showUploadRequestScanSection" />

            <MembershipRequestManualSection header="Подать заявку на членство" :open="showRequestSection" @click="showRequestSection = !showRequestSection" />

            <RequestPaymentManualSection header="Оплатить заявку" :open="showRequestPaymentSection" @click="showRequestPaymentSection = !showRequestPaymentSection" />
        </div>
    </div>
</template>

<script>
import ContactDataManualSection from '@/components/ContactDataManualSection.vue'
import PassportDataManualSection from '@/components/PassportDataManualSection.vue'
import RequestScanUploadManualSection from './RequestScanUploadManualSection.vue'
import PassportScanUploadManualSection from './PassportScanUploadManualSection.vue'
import PhotoUploadManualSection from './PhotoUploadManualSection.vue'
import MembershipRequestManualSection from './MembershipRequestManualSection.vue'
import RequestPaymentManualSection from './RequestPaymentManualSection.vue'

export default {
    data() {
        return {
            showPassportSection: false,
            showUploadRequestScanSection: false,
            showUploadPassportScanSection: false,
            showPhotoUploadSection: false,
            showContactDataSection: false,
            showRequestSection: false,
            showRequestPaymentSection: false,
        };
    },
    components: {
        ContactDataManualSection,
        PassportDataManualSection,
        RequestScanUploadManualSection,
        PassportScanUploadManualSection,
        PhotoUploadManualSection,
        MembershipRequestManualSection,
        RequestPaymentManualSection,
    },
    computed: {
        membershipRequest() {
          return this.$store.getters.getUserData.memberInfo?.membershipRequest
        },
    },
    mounted() {
        this.showRequestPaymentSection = (this.membershipRequest && !this.membershipRequest.paid);
    }
}
</script>
